import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";

export default function LeftNavigation({ disabled, handleOnClick }) {
  return (
    <div
      className="rounded-[8px] px-1 py-1"
      style={{ backgroundColor: disabled ? HNSColors.neutrals[800] : HNSColors.secondary[500] }}
    >
      <CustomIconButton
        iconVisible
        disabled={disabled}
        CustomIcon={
          <Svg
            name={SvgEnum.HisChevronLeft}
            color={disabled ? HNSColors.neutrals[500] : HNSColors.neutrals[900]}
            onClick={handleOnClick}
            sx={{ height: 24, width: 24 }}
          />
        }
      />
    </div>
  );
}
